export default "__VITE_ASSET__DUnZIYVw__"